import { render } from "./SelectedListItem.vue?vue&type=template&id=3e23a9c8"
import script from "./SelectedListItem.vue?vue&type=script&lang=js"
export * from "./SelectedListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__